<div class="w-100 px-1h pt-1h relative" cdkTrapFocus>
  <button
    type="button"
    class="reset-button absolute t-0 r-0 icon icon-close close"
    [mat-dialog-close]="false"
    data-test-id="button_close_dialog"
  ></button>
  <div mat-dialog-title class="medium">
    <h3>{{ 'common.label.settings' | translate }}</h3>
  </div>
  <div mat-dialog-content style="overflow: visible">
    <div class="row w-100 no-wrap">
      <div class="flex-0">
        <mat-selection-list #left [(ngModel)]="selectedIndex" [multiple]="false" class="pt-0">
          <mat-list-option [value]="0" style="height: 40px">
            <mat-icon mat-list-icon>settings</mat-icon>
            Email
          </mat-list-option>
        </mat-selection-list>
      </div>
      <div class="flex-1 pl-1q" style="min-width: 0; overflow: auto; max-height: 50vh;">
        <div>
          <mat-tab-group
            [headerPosition]="'below'"
            [@.disabled]="true"
            [selectedIndex]="selectedIndex[0]"
            [dynamicHeight]="true"
            [formGroup]="form"
          >
            <mat-tab>
              <app-rich-text
                class="w-100"
                inputClass="w-100"
                [inputLabel]="'common.label.signature' | translate"
                [showLabel]="true"
                formControlName="emailSignature"
                [extras]="['link', 'image']"
                [minHeight]="250"
              ></app-rich-text>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="w-100 mb-0 p-0 d-flex jc-end" style="min-height: auto; padding-bottom: 0">
    <button
      type="button"
      [attr.data-test-id]="[testId, 'save'] | join"
      class="button secondary-button"
      cdkFocusInitial
      (click)="submitForm(this.selectedIndex[0])"
    >
      {{ 'common.button.save' | translate }}
    </button>
  </div>
</div>
